import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { EmptyFilter, InFilter } from '@dofleini/query-builder';
import { createdATFilter, emailFilter, phoneFilter } from 'modules/common/constants/filters/common.filters';
import { userStatusFilter } from 'modules/security/users/constants/user-filters';
import { addressFilters } from 'lib/dfl-address-filter';
import { COUNTRIES } from 'constants/COUNTRIES';

export const clientTypeFilter: Filter = {
  filter: 'clients:filterName.types.title',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'types',
  field: 'types',
  transform: (value) => {
    const values = (Array.isArray(value) ? value : [value]).filter(Boolean);
    if (!values.length) return new EmptyFilter();
    return new InFilter({ field: 'types', value: values }).toQuery();
  },
  options: [{ value: 'BUSINESS', translate: true, label: 'clients:filterName.types.business' }],
};
export const orderCountFilter: Filter = {
  filter: 'dispatch:fields.metrics.suborderCount',
  translate: true,
  type: FilterType.NUMBER,
  key: 'orders',
  field: 'demographics.orders',
};

export const lastPurchaseDateFilter: Filter = {
  filter: 'clients:lastPurchaseDate',
  translate: true,
  type: FilterType.DATE,
  key: 'lastPurchaseDate',
  field: 'demographics.lastPurchaseDate',
};

const normalizeCountryText = (value?: string) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

const searchCountries = async ({ search }: any) => {
  const text = normalizeCountryText(search);
  const data = text ? COUNTRIES?.filter((country) => normalizeCountryText(country?.name).includes(text)) : COUNTRIES;
  return { data, total: data?.length || 0, page: 1 };
};

export const addressCountryFilter: Filter = {
  filter: 'common:country',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  key: 'addressCountry',
  field: 'demographics.addresses.country',
  queryKey: 'clients-address-countries',
  valueKey: 'code',
  labelKey: 'name',
  fetchFunc: searchCountries,
};

const addressFilterConfig = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'demographics.deliveryAddresses.country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'demographics.deliveryAddresses.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'demographics.deliveryAddresses.city',
  justUseFor: 'CU',
});

export const clientsAdminFilters = [
  emailFilter,
  phoneFilter,
  orderCountFilter,
  ...addressFilterConfig,
  addressCountryFilter,
  userStatusFilter,
  clientTypeFilter,
  lastPurchaseDateFilter,
  createdATFilter,
];

export const clientsFilters = [emailFilter, phoneFilter];
